import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';


export default function AboutPage() {
  const orgLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 污视频安全资讯平台',
    description: '了解安全资讯中心的品牌故事、核心价值与联系方式。我们致力于为用户提供全面的网络安全资讯。',
    url: 'https://example.com/about',
    mainEntity: {
      '@type': 'Organization',
      name: '安全资讯中心',
      description: '致力于为用户提供全面的网络安全资讯，帮助识别虚假页面、恶意下载和隐私风险。',
      foundingDate: '2024',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'contact@example.com',
        availableLanguage: ['Chinese'],
      },
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(orgLd)}</script>
      <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">关于我们</h1>

            <div className="w-full h-48 md:h-64 rounded-lg overflow-hidden mb-8">
              <img
                src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20office%20workspace%20with%20team%20collaborating%20on%20digital%20security%2C%20warm%20amber%20and%20teal%20accents%2C%20professional%20atmosphere%2C%20soft%20natural%20lighting%2C%20editorial%20style%20on%20light%20background&width=1200&height=600&seq=about-hero&orientation=landscape"
                alt="安全资讯中心团队"
                title="安全资讯中心 - 关于我们"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="space-y-8">
              <div>
                <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-3">品牌介绍</h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  安全资讯中心成立于2024年，是一个专注于网络安全信息传播的专业平台。我们的使命是帮助广大用户提升网络安全意识，识别网络世界中的各种风险与陷阱。我们深知，在信息爆炸的时代，虚假页面、恶意下载和隐私泄露等问题日益严重，普通用户往往缺乏足够的专业知识来保护自己。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mt-3">
                  我们的编辑团队由资深网络安全专家和信息安全从业者组成，持续追踪最新的安全动态和诈骗手法，将复杂的专业知识转化为通俗易懂的实用指南。无论您是普通网民还是技术爱好者，都能在这里找到有价值的安全资讯。
                </p>
              </div>

              <div>
                <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-3">核心价值</h2>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <div className="p-5 bg-background-100 rounded-lg border border-background-200/70">
                    <span className="w-10 h-10 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg mb-3">
                      <i className="ri-shield-check-line text-lg"></i>
                    </span>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-2">权威可信</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">所有内容经过严格审核，确保信息准确可靠，为用户提供值得信赖的安全指南。</p>
                  </div>
                  <div className="p-5 bg-background-100 rounded-lg border border-background-200/70">
                    <span className="w-10 h-10 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg mb-3">
                      <i className="ri-lightbulb-line text-lg"></i>
                    </span>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-2">通俗易懂</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">将复杂的网络安全知识转化为简单明了的语言，让每位用户都能轻松理解并应用。</p>
                  </div>
                  <div className="p-5 bg-background-100 rounded-lg border border-background-200/70">
                    <span className="w-10 h-10 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg mb-3">
                      <i className="ri-timer-line text-lg"></i>
                    </span>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-2">及时更新</h3>
                    <p className="text-xs text-foreground-600 leading-relaxed">密切关注安全动态，第一时间发布最新的安全资讯和风险预警，帮助用户抢先防范。</p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-3">信誉与口碑</h2>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  自成立以来，安全资讯中心已累计发布数百篇高质量安全资讯文章，帮助数十万用户提升了网络安全意识。我们的文章被多家主流媒体和平台转载引用，在行业内树立了良好的口碑。我们始终坚持以用户安全为核心，不以盈利为目的推送广告内容，确保每篇文章都真正服务于用户的实际需求。
                </p>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-4">
                  <div className="text-center p-4 bg-background-100 rounded-lg">
                    <div className="text-2xl font-heading font-bold text-primary-600">500+</div>
                    <div className="text-xs text-foreground-500 mt-1">原创文章</div>
                  </div>
                  <div className="text-center p-4 bg-background-100 rounded-lg">
                    <div className="text-2xl font-heading font-bold text-accent-600">30万+</div>
                    <div className="text-xs text-foreground-500 mt-1">月活跃用户</div>
                  </div>
                  <div className="text-center p-4 bg-background-100 rounded-lg">
                    <div className="text-2xl font-heading font-bold text-primary-600">98%</div>
                    <div className="text-xs text-foreground-500 mt-1">用户满意度</div>
                  </div>
                  <div className="text-center p-4 bg-background-100 rounded-lg">
                    <div className="text-2xl font-heading font-bold text-accent-600">50+</div>
                    <div className="text-xs text-foreground-500 mt-1">合作媒体</div>
                  </div>
                </div>
              </div>

              <div className="bg-background-100 rounded-lg p-6 md:p-8 border border-background-200/70">
                <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-4">联系我们</h2>
                <div className="space-y-3 text-sm md:text-base text-foreground-700">
                  <div className="flex items-center gap-3">
                    <span className="w-8 h-8 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg shrink-0">
                      <i className="ri-mail-line"></i>
                    </span>
                    <span>电子邮箱：contact@example.com</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="w-8 h-8 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg shrink-0">
                      <i className="ri-phone-line"></i>
                    </span>
                    <span>客服电话：400-XXX-XXXX（工作日 9:00-18:00）</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="w-8 h-8 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg shrink-0">
                      <i className="ri-map-pin-line"></i>
                    </span>
                    <span>办公地址：中国北京市朝阳区网络安全产业园 A座</span>
                  </div>
                </div>
                <div className="mt-4 flex flex-wrap gap-2">
                  <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-50 text-foreground-600 rounded-full hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" rel="nofollow" aria-label="微信">
                    <i className="ri-wechat-line"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-50 text-foreground-600 rounded-full hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" rel="nofollow" aria-label="微博">
                    <i className="ri-weibo-line"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-50 text-foreground-600 rounded-full hover:bg-primary-500 hover:text-background-50 transition-all cursor-pointer" rel="nofollow" aria-label="邮箱">
                    <i className="ri-mail-send-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}